function CreateEvent() {
    return (  
        <div>
            Hello World
        </div>
    );
}

export default CreateEvent;